module.exports = __webpack_public_path__ + "img/dori_Kalsiy_D3-1.5a73ff2c.jpg";